import { makeStyles } from "@material-ui/core"

export const styles = makeStyles((theme) => ({

  container: {
    width: "900px",
    display: "flex",
    justifyContent: "center"
  },
  
  cardSelectImg: {
    height: "2rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    margin: "1.5rem",
    padding: "1.2rem"
  }
}))